import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';
import { AuthenticationService } from './share-modul/services/authentication/authentication.service';
import { TranslationHelperService } from './share-modul/services/translation-helper/translation-helper.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [MessageService]
})

export class AppComponent implements OnInit {

  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>();
  public isLoggedin: boolean = false;
  public isSuperAdmin: boolean = false;
  //#endregion

  //#region Constructor
  constructor(
    private translationHelperService: TranslationHelperService,
    public authenticationService: AuthenticationService) {
  }

  ngOnInit(): void {
    this.initTranslate();
    this.authenticationService.loginUser.pipe(takeUntil(this.unsubscribe)).subscribe(response => {
      this.isLoggedin = !!response;
    });
    this.authenticationService.isLoggedIn$.subscribe((result) =>
      this.isLoggedin = result
    );
    // this.authenticationService.isSuperAdmin$.subscribe((result) =>
    //   this.isSuperAdmin = result
    // );
  }
  //#endregion

  //#region Private Methods
  private initTranslate(): void {
    this.translationHelperService.initializeTranslate();
  }
  //#endregion
}
